export const makeSelect = (originalSelect, option) => {
    if (option === 'reset') {
        originalSelect.removeClass('custom-select-installed');
        originalSelect.parents('.custom-select-wrapper').find('.custom-select-container').remove();
    } else if (originalSelect.hasClass('custom-select-installed')) {
        return;
    }

    let requiredEl = null;
    if (originalSelect.parent().find('.required').length) {
        requiredEl = originalSelect.parent().find('.required').first();
    }
    let selectWrapper = originalSelect.parents('.custom-select-wrapper');

    if (!selectWrapper.length) {
        originalSelect.wrap('<div class="custom-select-wrapper">');
    }


    if (requiredEl){
        originalSelect.after(requiredEl)
    }
    originalSelect.css('display', 'none');
    originalSelect.addClass('custom-select-installed');


    var customSelectWrapper = originalSelect.parent();
    customSelectWrapper.data('wrapper_of',originalSelect.attr('name'));
    customSelectWrapper.attr('data-wrapper_of',originalSelect.attr('name'));

    var customSelect = $('<div class="custom-select-container"></div>');
    var options = originalSelect.find('option');
    customSelectWrapper.append(customSelect);

    var selectedContainer = $('<div class="selected-container"></div>');

    selectedContainer.append('<div class="custom-select-arrow"><i class="icon-oss-select-arrow"></i></div>');
    selectedContainer.append('<div class="custom-select-label"></div>');
    customSelect.append(selectedContainer);
    customSelect.append('<div class="custom-select-elements"></div>');

    var customSelectElements = customSelect.find('.custom-select-elements');

    const toggleElements = () => {
        if (!customSelect.hasClass('open')) {
            customSelect.addClass('open');
            customSelectElements.stop().slideDown();
        } else {
            setTimeout(function () {
                customSelect.removeClass('open');
            }, 400);
            customSelectElements.stop().slideUp();
        }
    }

    $.each(options, function (index, option) {

        let disapledOption = $(this).prop('disabled');
        let optionValue = $(option).prop('value');
        var optionLabel = $(option).text();

        var optionDom = $('<div class="custom-select-option"></div>');
        optionDom.text(optionLabel);
        optionDom.attr('data-value', optionValue);

        if (disapledOption) {
            optionDom.addClass('disabled');
        }

        if ($(option).attr('selected') || optionValue === originalSelect.val()) {
            optionDom.addClass('custom-select-option-selected');
            customSelect.find('.custom-select-label').text(optionLabel);
        }
        if (!optionValue.length) {
            return;
        }

        customSelectElements.append(optionDom);
        $(this).removeClass('active');

        optionDom.on('click', function (e) {
            $(this).parent().find(".active").removeClass('active');
            $(this).addClass('active');

            var val = $(this).data('value');
            customSelect.find('.custom-select-label').text($(this).text());

            originalSelect.val(val);
            originalSelect.trigger('change');
            if (!originalSelect.val() || !originalSelect.val().length) {
                customSelect.find('.custom-select-label').removeClass('with-value');
            } else {
                customSelect.find('.custom-select-label').addClass('with-value');
            }

            toggleElements();
            // $(".selected-container").removeClass('open');
            // $(".custom-select-elements").removeClass('open');
        });

    });

    selectedContainer.on('click', function (e) {
        toggleElements();
    });


}
